<template>
          <!-- contents -->
          <div id="contents">
            <div class="contents_wrap">
              <!-- contents_head -->
              <!-- breadcrumbs -->
              <skp-breadcrumbs @page-title="val => pageTitle = val" />
              <!-- //breadcrumbs -->
              <h2 class="pg_title">{{ pageTitle }}</h2>
              <!-- //contents_head -->

              <!-- srchTop_wrap -->
              <div class="srchTop_wrap">
                <article class="srch_basic">
                  <div class="srch_grup">
                    <ul class="w100">
                        <li class="tit_150">GBM</li>
                        <li data-input-type="select" class="w100-150">
                            <!-- 200515수정 S -->
                            <fieldset class="ui_fieldset ui_right">
                                <label class="checkbox-wrap">
                                    <input type="checkbox"  v-model="selectAll" @change="toggleSelectAll"><i class="check-icon"></i>
                                    <em>All</em>
                                </label>
                                <label class="checkbox-wrap" v-for="item in checkList" :key="item.NMGBM">
                                    <input type="checkbox" :value="item.CDGBM" v-model="checkedNames" @change="onUserLevelChange"><i class="check-icon"></i>
                                    <em>{{item.NMGBM}}</em>
                                </label>
                            </fieldset>
                            <!-- 200515수정 E -->
                        </li>
                    </ul>
                    

                    <ul class="w100">
                        <li class="tit_150">Inquory</li>
                            <li data-input-type="select" class="w100-150">
                                <fieldset class="ui_fieldset set_2">
                                    <div>
                                        <select class="slt_white w100" v-model="inquiry1Code" @change="inquiryList(2)">
                                            <option value="">{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                            <option
                                                v-for="item in inquiry1CodeList"
                                                :value="item.CD"
                                                >{{ item.CD_NAME }}</option
                                            >
                                        </select>
                                    </div>
                                    <div>
                                        <select class="slt_white w100" v-model="inquiry2Code">
                                            <option value="">{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                            <option
                                                v-for="item in inquiry2CodeList"
                                                :value="item.CD"
                                                >{{ item.CD_NAME }}</option
                                            >
                                        </select>
                                    </div>
                                </fieldset>
                            </li>
                    </ul>
                    
                    <ul class="w50">
                        <li class="tit_150">
                            Period <em class="txt_mandatory">*</em>
                        </li>
                        <dd data-input-type="date">
                            <fieldset class="ui_fieldset">
                                <span class="date-wrap">
                                    <label>
                                        <input id="fromDate" type="text" class="date_input w100p bg_white" readonly :placeholder="$t('FIELD.KNOWLEDGE.SEARCH.FROMDATE')">
                                        <a href="javascript:" class="in_btn" id="icoFromDate"><i class="ico_date"></i><span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span></a>
                                    </label>
                                    <div id="from-picker-container" style="margin-top: -1px;"></div>
                                </span>
                                <em class="txt_space"></em>
                                <span class="date-wrap">
                                    <label>
                                        <input id="toDate" type="text" class="date_input w100p bg_white" readonly :placeholder="$t('FIELD.KNOWLEDGE.SEARCH.TODATE')">
                                        <a href="javascript:" class="in_btn" id="icoToDate"><i class="ico_date"></i><span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span></a>
                                    </label>
                                    <div id="to-picker-container" style="margin-top: -1px;"></div>
                                </span>
                            </fieldset>
                        </dd>
                    </ul>
                    
                  </div>
                  <div class="srch_grupR_bottom">
                    <span class="btn">
                      <a href="javascript:" class="btn_srch" @click="search(1)">Search</a>
                    </span>
                  </div>
                </article>
              </div>
              <!-- Grid -->
              <!-- Grid -->
              <div class="grid_wrap number-cell">
                    <!-- Count -->
                <!-- <div class="grid_total">
                    Total&nbsp;Count&nbsp;
                    <em>{{ totalCount | numberFormat }}</em>
                </div> -->
                <div class="btn_wrap">
                    <a
                            href="javascript:"
                            class="btn_white"
                            @click="excelDownload()"
                            title
                        >{{ $t('FIELD.GLOBAL.EXCELDOWNLOAD') }}</a>
                </div>
                <!-- Grid -->
                <toast-grid
                    :gridId="gridId"
                     ref="GridId"
                    :data="gridData"
                    :columns="columns"
                    :options="options"
                    :header="header"
                    :key="gridKey"
                    :pageOptions="pageOptions"
                    :isTotalCount="false"
                    :click="contentClick"
                />
            </div>

            <!-- <div class="paginate">
                <sdl-pagination
                    :current-page="currentPage"
                    :total-rows="totalCount"
                    :per-page="perPage"
                    @change="search"
                    align="center"
                />
             </div> -->
            </div>
          </div>
          <!-- contents -->

</template>

<script>
import Vue                                  from 'vue';
import { mapActions, mapGetters }           from 'vuex';
import _                                    from 'lodash';
import $                                    from 'jquery';
import qs                                   from 'query-string';
import axios                                from 'axios';
import moment                               from 'moment';
import api                                  from '@/service';
import store                                from '@/vuex/store';
import constants                            from '@/constants';
import SDLLocale                            from '@/mixin/SDLLocale';
import { SDLUtil, StringUtil, MenuUtil }    from '@/utils';
import { EventBus }                         from '@/utils/EventBus';


import SKPBreadcrumbs                       from '~vb/main/SKPBreadcrumbs';
import DatePicker                           from '~c/DatePicker';
import ToastGrid                            from '~c/ToastGrid';

import ExcelDownloadPopup                   from '~vb/common/ExcelDownloadPopup';

// java to moment dateformat parser
require('moment-jdateformatparser');

const fetchGridData = params => axios.post(
    `${SDLUtil.API_URL}/basis/admin/statisticsManager/gBMQnAStatusSearch.skp`,
    qs.stringify(params),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

export default {
    name : 'UnreadList',
    props : {

    },
    data() {
        return {
            isProcess: true,

            
            inquiry1Code: '',
            inquiry2Code: '',
            inquiry1CodeList: [],
            inquiry2CodeList: [],

            FROM_DATE: {},     
            TO_DATE: {},    

            selectAll: true,

            checkList: [],
            checkedNames:[],
            

            pageTitle : '',
            perPage: parseInt(localStorage.getItem('listRows') || 10),
            currentPage: 1,
            totalCount : 0,
            gridId : "unreadGrid",
            gridKey: 0,
            gridData : [],
            header: {
                height: 80,
                complexColumns: [
                    {
                        header: 'On-Time Answer',
                        name: 'mergeColumn1',
                        childNames: ['TOTAL', 'D', 'D1', 'D2']
                    },
                ]
            },
            columns : [
                {
                    header: "GBM",
                    name: "CDGBM_CNV",
                    //width: 200,
                    align: "left",
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "Inquiry Type",
                    name: "INQUIRY_TYPE1",
                    width: 200,
                    align: "left",
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "Inquiry",
                    name: "INQUIRY_CNT",
                    align: "center",
                    width: 120,
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "Answer",
                    name: "ANSWER_CNT",
                    align: "center",
                    width: 80,
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "Open",
                    name: "PENDING_CNT",
                    width: 80,
                    align: "center",
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "Answer Rate(%)",
                    name: "ANS_RATE",
                    width: 110,
                    align: "center",
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "Total",
                    name: "TOTAL",
                    width: 100,
                    align: "center",
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "D",
                    name: "D",
                    align: "center",
                    width: 80,
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "D+1",
                    name: "D1",
                    align: "center",
                    width: 80,
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "D+2",
                    name: "D2",
                    align: "center",
                    width: 80,
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "On-Time Feedback(%)",
                    name: "ONTIME_RATE",
                    align: "center",
                    width: 150,
                    sortable: false,
                    resizable: true,
                },
            ],
            options : {
                scrollX: true,
                scrollY: false,
                header: { height: 45 },
                rowHeight: 45,
            },
            pageOptions : {},
        }
    },
    computed: {
        ...mapGetters({
            userRoles:  'getRoles',
            userCorpCd: 'getCorpCd',
            params:     'getParams',
            locale:     'getLocale',
            menus:      'getMenus',
            loginNo:    'getLoginNo',
            loginRhq:   'getLoginRhq'
        }),
        getDateformat() {
            return localStorage.getItem('mDateFormat');
        },
        getLoginUser() {
            return SDLUtil.getLoginedUserInfo();
        },
        getLoginRHQCd() {
            return this.loginRhq || '';
        },
        getLoginCompanyCd() {
            return this.userCorpCd || '';
        },
        getLoginNo() {
            return this.loginNo || '';
        },
        getUserRole() {
            return this.userRoles || '';
        },
    },
    components: {
        'skp-breadcrumbs' : SKPBreadcrumbs,
        'toast-grid' : ToastGrid
    },
    methods: {
        
        async inquiryList(v) {
            let type = 'inquiryType' + v;
            if (v === 3) {
                type = 'kpi_charge';
            } else if (v === 4) {
                type = 'gbm_cd';
            }
            return await axios
                .post(
                    `${SDLUtil.API_URL}/basis/common/inquiryItem/inquiryItemList.skp`,
                    qs.stringify({
                        type: type,
                        useyn: 'Y',
                        deptLevelCd: this.deptLevelCd,
                        deptNo: this.deptNo,
                        value: this.inquiry1Code,
                    }),
                )
                .then(resp => {
                    if (v === 1) {
                        this.inquiry1Code = '';
                        this.inquiry1CodeList = resp.data.result.rowData;
                        this.inquiryList(2);
                    } else if (v === 2) {
                        this.inquiry2Code = '';
                        this.inquiry2CodeList = resp.data.result.rowData;
                    } else if (v === 3) {
                        this.kpiChargeList = resp.data.result.rowData;
                    } else if (v === 4) {
                        this.gbmCdList = resp.data.result.rowData;
                    }
                });
        },
        // GBM
        getGBMList() {
            SDLUtil.showLoadingBar(true);
            return axios
                .post(
                    `${SDLUtil.API_URL}/basis/admin/statisticsManager/gBMList.skp`,
                    qs.stringify({}),
                )
                .then(res => {
                        let data = res.data;
                        this.checkList = data.result;
                        this.checkList = this.checkList.filter(item => !["4", "5", "12", "17"].includes(item.CDGBM));
                        // 초기화.
                        this.checkedNames = [];
                        this.checkedNames = this.checkList.map(item => item.CDGBM);
                        // -------------------------------------------------------
                        SDLUtil.showLoadingBar(false);
                    })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },

        // 버튼 이벤트
        async search(pageNo) {

            let mFormat = moment().toMomentFormatString(localStorage.getItem('dateFormat') || 'MM.dd.yyyy');
            let startDate = this.rangePicker.getStartDate();
            let endDate = this.rangePicker.getEndDate();
            let searchFromDt = startDate ? moment(startDate).formatWithJDF(mFormat) : '';
            let searchToDt = endDate ? moment(endDate).formatWithJDF(mFormat) : '';
            if (parseInt((endDate - startDate) / (24 * 60 * 60 * 1000)) > 7) {
                SDLUtil.alert({
                    title: 'Alert',
                    msg: 'The maximum duration of a search is one week.',
				});
                return false;
            }
            
            let validContents = this.registVerifyContents();
            let checkedVal = "";
            if(this.checkedNames.length > 0) {
                checkedVal = this.checkedNames.join(',');
            }    
            if(validContents) {
                if (!pageNo) pageNo = 1;
                const mFormat = localStorage.getItem('mDateFormat');
                let params = {
                    page             : pageNo,
                    INQUIRY1CODE     : this.inquiry1Code,
                    INQUIRY2CODE     : this.inquiry2Code,
                    FROM_DATE        : this.rangePicker.getStartDate() ? moment(this.rangePicker.getStartDate()).format(mFormat) : '',
                    TO_DATE          : this.rangePicker.getEndDate() ? moment(this.rangePicker.getEndDate()).format(mFormat) : '',
                    CHECKEDVAL       : checkedVal
                };

                SDLUtil.showLoadingBar(true);
                const response = await fetchGridData(params)
                    .then(res => {
                        let data = res.data;
                        this.gridData = data.result;
                        this.gridKey++;
                        this.currentPage = pageNo;

                        this.$nextTick(() => {
                            let idx = 0;    
                            for(let row of this.gridData){
                                if(row.CDGBM_CNV.indexOf("Total") >= 0 ) {
                                    this.$refs.GridId.addRowClassName(idx, 'sub_total');
                                }
                                idx++;
                            }
                        });

                        SDLUtil.showLoadingBar(false);
                    })
                    .catch(err => {
                        SDLUtil.errorAlert(err);
                        SDLUtil.showLoadingBar(false);
                    });
            }
        },
        // 컨텐츠 클릭 이벤트 -> KnowledgeListGrid
        contentClick(e, rowData, grid) {
            
        },
        excelDownload() {
            SDLUtil.confirm({
                msg: 'Do you want to download the Excel file?<br>Data will be download up to 1000 lines.',
                onOkEvt: () => {
                    let checkedVal = "";
                    if(this.checkedNames.length > 0) {
                        checkedVal = this.checkedNames.join(',');
                    }      
                    SDLUtil.showLoadingBar(true);
                    const mFormat = localStorage.getItem('mDateFormat');
                    return axios
                        .post(
                            `${SDLUtil.API_URL}/basis/admin/statisticsManager/gBMQnAStatusExcel.skp`,
                            qs.stringify({
                                INQUIRY1CODE     : this.inquiry1Code,
                                INQUIRY2CODE     : this.inquiry2Code,
                                FROM_DATE        : this.rangePicker.getStartDate() ? moment(this.rangePicker.getStartDate()).format(mFormat) : '',
                                TO_DATE          : this.rangePicker.getEndDate() ? moment(this.rangePicker.getEndDate()).format(mFormat) : '',
                                CHECKEDVAL       : checkedVal,
                            }),
                        )
                        .then(resp => {
                            SDLUtil.showLoadingBar(false);
                            if (resp.data.EXCEL_FILES.length > 0) {
                                SDLUtil.show(
                                    ExcelDownloadPopup,
                                    {
                                        title: SDLUtil.getMsgProp('TITLE.EXCEL.DOWNLOAD'),
                                        excelFiles: resp.data.excelFiles,
                                    },
                                    {
                                        height: 'auto',
                                    },
                                );
                            }
                            SDLUtil.showLoadingBar(false);
                        })
                        .catch(err => {
                            Vue.$log.error(err);
                            SDLUtil.errorAlert(err);
                            SDLUtil.showLoadingBar(false);
                        });
                },
            });
        },
        registVerifyContents() {
            let validList = [''];
            if(SDLUtil.isNull(this.rangePicker.getStartDate()))    validList.push((validList.length > 0 ? '<br/>' : '') + '<span class="txt_color1">' + 'Period' + '</span>');
            if(SDLUtil.isNull(this.rangePicker.getEndDate()))    validList.push((validList.length > 0 ? '<br/>' : '') + '<span class="txt_color1">' + 'Period' + '</span>');
            if(validList.length > 1) {
                SDLUtil.alert({
                    msg: 'The following fields are required to start search.' + '<br/>' + '<span class="txt_color1">' + 'Period' + '</span>',
                    class: 'sm_size'
                });
                return false;
            } else {
                return true;
            }
        },
        toggleSelectAll(e) {
            if (this.selectAll) {
                this.checkedNames = [];
                this.checkedNames = this.checkList.map(item => item.CDGBM);
            } else {
                this.checkedNames = [];
            }
        },
        onUserLevelChange(e) {
            this.selectAll =
            this.checkedNames.length == this.checkList.length ? true : false;
        },

    },
    created() {
        
    },

    mounted() {
        this.$nextTick(() => {
            this.getGBMList();
            this.inquiryList(1);
//            let toDate = new Date();    
//            let fromDate = toDate.setMonth(toDate.getMonth() - 1);
            //this.FROM_DATE = DatePicker.create('from-picker-container', 'fromDate', 'icoFromDate', 'en', {} ,fromDate);
            //this.TO_DATE   = DatePicker.create('to-picker-container', 'toDate', 'icoToDate', 'en', {} ,new Date());    
            
            // Date prev => (new moment()).add(-1, 'month').toDate(),
            this.rangePicker = DatePicker.createRangeWithOpener(
                            'from-picker-container', 'fromDate', 'icoFromDate',
                            'to-picker-container', 'toDate', 'icoToDate',
                            { type: 'date', locale: 'en', showToday: false },
                            (new moment()).add(-7, 'days').toDate(),
                            (new moment()).toDate()
            );  
        });
    },
    beforeDestroy() {

    }
};
</script>

<style>
    /*  사용시 해당 컨포넌트에서만 사용 */
.zindex9999 { z-index: 99999999; }
.top20 {top: -20px;}
.float-none {float: none;}
.ftColor { color: dodgerblue!important; font-weight: bold!important; }
.sub_total {
  background: #f9f9f9 !important;
  font-weight: bold;
  width: 100% !important;
  height: 40px !important;
}
.tui-datepicker {
    z-index: 9999;
    border: 1px solid #aaa;
    background-color: white;
    position: absolute;
}
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/admin/statisticsManager/gBMQnAStatusList.vue